export default "__VITE_ASSET__6140688a__"